/**
 * offsetSeries(values, bars) — deslocamento no tempo de uma série de saída.
 *
 * A unidade é BARRA, sempre — daí o nome do parâmetro. No repo há quatro
 * "offset/shift" que são de PREÇO (`shift` do Keltner, `levelOffset` do Darvas,
 * `Shift Percentage` do High Low, `Level Offset` do ChartIQ); este é o único de
 * tempo, e a chave de config correspondente é `offsetBars` pelo mesmo motivo.
 *
 * É o MESMO operador que `REF` do engine Silverlight (`silverlightDsl.ref`,
 * porte 1:1 de `FormulaBase.REF`), na borda com o chart: preenche `undefined`
 * onde o `ref` preencheria `NaN`.
 *
 *   out[i] = values[i − bars]      (fora do range → undefined)
 *
 * - `bars > 0` desloca a curva para a DIREITA (o valor de N barras atrás
 *   aparece na barra atual) — é o `DESLOCAR` positivo do legado.
 * - `bars < 0` desloca para a ESQUERDA (referencia o futuro) — é o Chikou do
 *   Ichimoku e o `DESLOCAR` negativo do engine.
 * - `bars === 0` retorna a MESMA referência (identidade, custo zero — o caminho
 *   default de todo indicador não paga nada).
 *
 * **O array NUNCA cresce.** O que passa do fim é truncado, exatamente como no
 * engine (que trabalha com `FormulaData` de comprimento fixo): o Silverlight
 * não plota além da última barra, e a paridade exige o mesmo domínio. Quem
 * precisa desenhar à direita da última barra usa um caminho separado — ver
 * `ichimoku.computeFutureProjection` + `IchimokuFutureCloudOverlay` (#161).
 *
 * Não muta `values`.
 *
 * ⚠️ Uma divergência DELIBERADA vs `ref`: com `|n| > len` o engine devolve a série
 * em ZERO (o `double[]` do C# nasce zerado e o preenchimento de NaN só roda com
 * `NI <= len` — `silverlightDsl.js:109`), o que plotaria uma reta colada no zero.
 * Aqui devolve `undefined`. Coberto em `__tests__/offsetSeries.test.js`.
 */
export default function offsetSeries(values, bars) {
  const offset = Math.trunc(bars) || 0;
  if (offset === 0) return values;

  const len = values.length;
  const out = new Array(len);
  for (let i = 0; i < len; i++) {
    const j = i - offset;
    out[i] = j >= 0 && j < len ? values[j] : undefined;
  }
  return out;
}
